/*
  Popup: dodaj produkt. Pokazuje się, gdy łączna ilość sztuk wybranych produktów w koszyku
  mieści się w zakresie (np. dokładnie 1 szt.) i pozwala dodać produkt do koszyka jednym kliknięciem.
  Niczego nie zdejmuje z koszyka. Gratis za 1 zł dokłada osobno aplikacja BOGOS.
*/
if (!customElements.get('add-product-popup')) {
  customElements.define(
    'add-product-popup',
    class AddProductPopup extends DrawerComponent {
      get requiresBodyAppended() {
        return false;
      }

      connectedCallback() {
        super.connectedCallback();

        const list = (str) =>
          (str || '')
            .split(',')
            .map((s) => s.trim())
            .filter(Boolean);

        this.triggerIds = list(this.dataset.triggers).map(Number);
        this.offerVariantId = Number(this.dataset.offerVariantId) || null;
        this.addQuantity = Number(this.dataset.addQuantity) || 1;
        this.minQty = Number(this.dataset.minQty) || 1;
        this.maxQty = Number(this.dataset.maxQty) || 1;
        this.endTs = Number(this.dataset.endTs) || null;
        this.dismissKey = this.dataset.dismissKey;
        this.ignoreVariantIds = list(this.dataset.ignoreVariantIds).map(Number);
        this.ignoreZeroPrice = this.dataset.ignoreZeroPrice === 'true';

        if (!this.triggerIds.length || !this.offerVariantId) return;

        this.ctaBtn = this.querySelector('[data-add-product-cta]');
        this.dismissBtn = this.querySelector('[data-add-product-dismiss]');
        this.closeBtn = this.querySelector('[data-add-product-close]');
        this.errorEl = this.querySelector('[data-add-product-error]');

        this.ctaBtn.addEventListener('click', this.addOffer.bind(this));
        if (this.dismissBtn) this.dismissBtn.addEventListener('click', () => this.dismiss());
        // Zamknięcie krzyżykiem, tłem lub Esc = rezygnacja do końca sesji
        if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.setDismissed());
        if (this.overlay) this.overlay.addEventListener('click', () => this.setDismissed());
        document.addEventListener(
          'keyup',
          (event) => {
            if (event.code === 'Escape' && this.open && !Shopify.designMode) this.setDismissed();
          },
          { signal: this.abortController.signal }
        );

        // W edytorze motywu nie otwieramy automatycznie (podgląd po zaznaczeniu sekcji)
        if (Shopify.designMode) return;

        this._checkListener = () => this.fetchCartAndCheck();
        document.addEventListener('cart:updated', this._checkListener);
        window.FoxTheme.DOMready(this._checkListener);
      }

      disconnectedCallback() {
        super.disconnectedCallback();
        if (this._checkListener) {
          document.removeEventListener('cart:updated', this._checkListener);
        }
      }

      isDismissed() {
        try { return sessionStorage.getItem(this.dismissKey) === '1'; } catch (e) { return false; }
      }
      setDismissed() {
        try { sessionStorage.setItem(this.dismissKey, '1'); } catch (e) {}
      }
      dismiss() {
        this.setDismissed();
        this.hide();
      }

      isExpired() {
        return !!this.endTs && Date.now() / 1000 > this.endTs;
      }

      // Gratisy (np. dodane przez BOGOS) nie liczą się do warunku
      isIgnoredLine(item) {
        if (this.ignoreVariantIds.includes(item.variant_id)) return true;
        if (this.ignoreZeroPrice && item.final_price === 0) return true;
        return false;
      }

      fetchCartAndCheck() {
        fetch('/cart.js')
          .then((r) => r.json())
          .then((cart) => this.checkCart(cart))
          .catch(() => {});
      }

      // Łączna ilość sztuk produktów z listy (po odfiltrowaniu gratisów)
      triggerQuantity(cart) {
        return cart.items
          .filter((it) => !this.isIgnoredLine(it) && this.triggerIds.includes(it.variant_id))
          .reduce((sum, it) => sum + it.quantity, 0);
      }

      checkCart(cart) {
        if (Shopify.designMode || !cart || !cart.items) return;

        if (this.isDismissed() || this.isExpired()) {
          if (this.open) this.hide();
          return;
        }

        const qty = this.triggerQuantity(cart);
        if (qty >= this.minQty && qty <= this.maxQty) {
          this.showError(false);
          if (!this.open) this.show();
        } else if (this.open) {
          this.hide();
        }
      }

      showError(visible) {
        if (this.errorEl) this.errorEl.hidden = !visible;
      }

      addOffer() {
        if (Shopify.designMode) return;
        this.ctaBtn.disabled = true;
        this.showError(false);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: this.offerVariantId, quantity: this.addQuantity }),
        })
          .then((r) => {
            if (!r.ok) throw new Error('cart/add ' + r.status);
            return r.json();
          })
          .then(() => {
            this.setDismissed();
            this.hide();
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
          })
          .catch((err) => {
            console.error('Popup dodaj produkt error:', err);
            this.showError(true);
          })
          .finally(() => {
            this.ctaBtn.disabled = false;
          });
      }
    }
  );
}